export default "__VITE_ASSET__Crv60zhg__"